import { Suspense, useMemo } from 'react'

import { Navigate, RouteObject, useRoutes } from 'react-router-dom'

import { AuthProvider } from 'modules/Auth/components/AuthProvider'
import { usePermissions } from 'modules/Auth/hooks/usePermissions'
import { ModuleName } from 'modules/Auth/types/api'

import { ContentLoader } from 'shared/ui/ContentLoader'

import { accessManageRoutes } from './routes/AccessManage'
import { analyticsRoutes } from './routes/Analytics'
import { clientsRoutes } from './routes/Clients'
import { knowledgeBaseRoutes } from './routes/KnowledgeBase'
import { ordersRoutes } from './routes/Orders'
import { supportServiceRoutes } from './routes/SupportService'
import { logsRoutes } from './routes/UserLogs'
import { DashboardWrapper } from './ui'

export type RouteModulesMap = { [key in ModuleName]: RouteObject[] }

const routeModulesMap: RouteModulesMap = {
  ORDERS: ordersRoutes,
  CRM_USER: accessManageRoutes,
  LOGS: logsRoutes,
  CLIENTS: clientsRoutes,
  ANALYTICS: analyticsRoutes,
  WIKI: knowledgeBaseRoutes,
  CLIENT_SUPPORT: supportServiceRoutes,
}

export const DashboardRoutes = () => {
  const { filterRoutesByPermissions, isFetching, isLoading } = usePermissions()

  const filteredRoutes = useMemo(() => {
    if (isFetching || isLoading) return []
    return filterRoutesByPermissions({ routeModulesMap })
  }, [filterRoutesByPermissions, isFetching])

  const routes: RouteObject[] = [
    {
      path: '/',
      element: (
        <Suspense fallback={<ContentLoader />}>
          <AuthProvider>
            {isFetching || isLoading ? <ContentLoader /> : <DashboardWrapper />}
          </AuthProvider>
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: (
            <Navigate
              to="orders"
              replace
            />
          ),
        },
        ...filteredRoutes,
        {
          path: '*',
          element: (
            <Navigate
              to="/not-found"
              replace
            />
          ),
        },
      ],
    },
  ]

  return useRoutes(routes)
}
